/**
 * The wizard's steps, named rather than numbered so adding a fourth cannot
 * silently shift an off-by-one in the indicator or the footer.
 */
export const PROTOCOL_STEPS = ["dates", "issues", "content"] as const;

export type ProtocolStep = (typeof PROTOCOL_STEPS)[number];

export function protocolStepNumber(step: ProtocolStep): number {
  return PROTOCOL_STEPS.indexOf(step) + 1;
}
